import {Component, signal, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {HttpClient, HttpClientModule, HttpHeaders} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {of} from "rxjs";
import {UserService} from '@services/user.service';
import {OdooService} from '@services/odoo.service';
import {ApiService} from '@services/api.service';
import {Response} from '@services/api.service';

@Component({
  selector: 'app-request-form',
  imports: [HttpClientModule, ReactiveFormsModule, CommonModule],
  templateUrl: './request-form.component.html',
  styleUrl: './request-form.component.css'
})
export class RequestFormComponent implements OnInit {

  selectedFiles: File[] = [];
  base64Files: any[] = [];
  result: string = '';

  requestTypes: any[] = [];
  exerciseTypes: any[] = [];
  requestTypeDescription: string = '';

  requestForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    mail: new FormControl('', [Validators.required, Validators.email]),
    requestTypeId: new FormControl('', Validators.required),
    exerciseTypeId: new FormControl('', Validators.required),
    notes: new FormControl('', Validators.required),
    attachments: new FormControl<any[]>([])
  });

  submitted = signal(false);


  constructor(
    private http: HttpClient,
    private userService: UserService,
    private odooService: OdooService,
    private apiService: ApiService,
    ) {
  }

  ngOnInit() {
    this.fetchRequestTypes();
    this.fetchExerciseTypes();


    let mailForm = this.requestForm.get("mail") as FormControl
    if (mailForm) {
      mailForm.setValue(this.userService.getUser()?.username);
    }
  }

  fetchRequestTypes() {
    this.apiService.getRequestTypes().pipe(
      map(response => response.data.sort((a:any, b:any) => a.label.localeCompare(b.label))),
      catchError(error => {
        console.error("Errore nel recupero dei types", error);
        return of([])
      })
    ).subscribe(
      types => {
        this.requestTypes = types;
      }
    )
  }

  fetchExerciseTypes() {
    this.apiService.getExerciseTypes().pipe(
      map(response => response.data.sort((a:any, b:any) => a.label.localeCompare(b.label))),
      catchError(error => {
        console.error("Errore nel recupero dei types", error);
        return of([])
      })
    ).subscribe(
      types => {
        this.exerciseTypes = types;
      }
    )
  }

  onRequestTypeChange(event: Event) {
    const selectedElement = event.target as HTMLSelectElement;


    const selectedRequestType = this.requestTypes.find(r => r.id == selectedElement.value);

    this.requestTypeDescription = selectedRequestType.description;

    const attachmentControl = this.requestForm.get('attachments');
    if (attachmentControl) {
      if (selectedRequestType.requires_attachment) {
        attachmentControl.setValidators(Validators.required);
      } else {
        attachmentControl.setValidators(null);
      }
      attachmentControl.updateValueAndValidity()
    }
  }


  async readBase64File(file: File) {
    return await new Promise((resolve => {
      let reader = new FileReader();
      reader.onload = (e) => resolve(reader.result);
      reader.readAsDataURL(file);
    }));
  }


  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files);

      this.selectedFiles.forEach(file => {

        this.readBase64File(file).then(value => {
          this.base64Files.push({
            filename: file.name,
            filetype: file.type,
            size: file.size,
            base64: (value as string).split(',')[1]
          })
        })
      })
    }

  }

  newRequest() {
    this.submitted.set(false);
    this.requestForm.reset();
    this.result = '';
  }

  onSubmit() {
    if (this.requestForm.valid) {


      const formData = {
        ...this.requestForm.value,
        attachments: this.base64Files
      }

      const jsonPayload = JSON.stringify(formData, null, 2);

      this.apiService.createRequest(jsonPayload).subscribe({
        next: (response: any) => {
          this.submitted.set(true);
          this.result = response.result.message

        },
        error: (error) => {
          this.result = error.error.message
        },
        complete: () => {

        }
      });

    }
  }

}
